import React, {useMemo, useState} from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import moment from 'moment';
import {SelectionMode, IntervalOptions, Interval} from '@models/index';


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const ReportSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null);
  
  const defaultDisableRane = useMemo(() => [{
    disabled: true,
    start: moment().add(1, "d"),
    end: moment("3000/01/01")
  }] , []);
  
  const disabledEndDateRange = useMemo(() => {
    return startDate ? [{
      disabled: true,
      start: moment("1970/01/01"),
      end: moment(startDate).add(-1, "d")
    }, ...defaultDisableRane] : defaultDisableRane
  }, [startDate]);
  
  const inputs = [{
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      onChange: (date) => setStartDate(date),
      ranges:[{
        disabled: true,
        start: moment().add(1, "d"),
        end: endDate ? moment(endDate).add(-1, "d") : moment("3000/01/01")
      }]
    }
  }, {
    name: "to",
    label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      onChange: (date) => setEndDate(date),
      disabled: startDate ? false : true,
      ranges: disabledEndDateRange
    }
  },{
    name: "interval",
    label: <FormattedMessage id="app.interval" defaultMessage={`Interval`}/>,
    type: SearchInputType.SELECT,
    options: IntervalOptions,
    selectionType : SelectionMode.DEFAULT,
    size: 6,
    InputProps:{
      defaultValue : Interval.Day
    }
  }];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};

export default ReportSearch;